import { render, staticRenderFns } from "./OCrudDialog.vue?vue&type=template&id=c5f0e198&scoped=true"
import script from "./OCrudDialog.vue?vue&type=script&lang=js"
export * from "./OCrudDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f0e198",
  null
  
)

export default component.exports